import { fetchJSON as fetchAPI } from './client';

export type SprintDashboard = {
  sprint_id: string; objectives: number; validation_modules: number;
  lifecycle_stages: number; provider_interfaces: number; background_jobs: number;
  quality_gates: number; backend_apis: number; generated_at: string;
};

export type SprintValidation = {
  valid: boolean; every_recommendation_measurable: boolean;
  every_recommendation_has_evidence: boolean; every_recommendation_evolves: boolean;
  confidence_updates_automatic: boolean; marketplace_dna_updated: boolean;
  knowledge_graph_updated: boolean; operating_brain_updated: boolean; gaps?: string[];
};

export type Val001Status = {
  sprint_id: string; objectives: number; validation_modules: number;
  recommendation_validation: boolean; scientific_measurement: boolean;
  confidence_evolution: boolean; status: string;
};

const GOVERNANCE_BASE = import.meta.env.VITE_GOVERNANCE_API ?? '/api/v1/governance';
const fetchG = <T,>(path: string, init?: RequestInit) => fetchAPI<T>(`${GOVERNANCE_BASE}${path}`, init);

export const recommendationValidationVal001Api = {
  dashboard: () => fetchG<SprintDashboard>('/val001/dashboard'),
  objectives: () => fetchG<{ objectives: { key: string; name: string; category: string }[] }>('/val001/objectives').then((r) => r.objectives),
  validationModules: () => fetchG<{ modules: { key: string; name: string; category: string }[] }>('/val001/validation-modules').then((r) => r.modules),
  lifecycleStages: () => fetchG<{ stages: { key: string; name: string; order: number }[] }>('/val001/lifecycle-stages').then((r) => r.stages),
  providers: () => fetchG<{ providers: { key: string; name: string; interface: string }[] }>('/val001/service-architecture').then((r) => r.providers),
  backgroundJobs: () => fetchG<{ jobs: { key: string; name: string; schedule?: string }[] }>('/val001/background-jobs').then((r) => r.jobs),
  qualityGates: () => fetchG<{ gates: { key: string; name: string; blocking: boolean }[] }>('/val001/quality-gates').then((r) => r.gates),
  validate: (attrs: Record<string, boolean>) =>
    fetchG<SprintValidation>('/val001/validate', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attrs }) }),
  status: () => fetchG<Val001Status>('/val001/status'),
};
